module.exports = __webpack_public_path__ + "static/img/footer-newpartner.82d023c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-newpartner.png
// module id = VJC5
// module chunks = 0